import { FC } from 'react'

import type { Space } from 'features/space/types/spaceDetail'

import { SafeLinkifiedText } from './SafeLinkifiedText'
import space_styles from './SpaceInformationSection.module.scss'

const DEFAULT_STAFF_IMAGE = '/owner_section_illustration.webp'

type Props = {
  space: Space
}

export const IntroductionBlock: FC<Props> = ({ space }) => {
  if (!space.introduction) return null

  const staffImageUrl = space.intro_staff_image_url || DEFAULT_STAFF_IMAGE

  return (
    <div className={space_styles.introduction}>
      <div className={space_styles.introductionProfile}>
        <div className={space_styles.introductionProfileImage}>
          <img
            src={staffImageUrl}
            alt=""
            onError={(e) => {
              ;(e.target as HTMLImageElement).src = DEFAULT_STAFF_IMAGE
            }}
            height="48px"
            width="48px"
          />
        </div>
      </div>
      <div className={space_styles.introductionProfileComment}>
        <p className={space_styles.comment}>
          <SafeLinkifiedText>{space.introduction}</SafeLinkifiedText>
        </p>
      </div>
    </div>
  )
}
